import { first } from 'rxjs/operators';

import { MatDialog, MatDialogConfig, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Component, Input, OnInit } from '@angular/core';
import { AlertService } from '@app/_services';
import { LazyLoadEvent, MessageService, ConfirmationService } from 'primeng/api';
import {RealEstateService} from "@app/_components/real-estate/real-estate.service";
import {RealEstate} from "@app/_components/real-estate/real-estate";
import Utils from "@app/_components/_shared/utils";
import { Msg } from '@app/_components/msg';
import { DialogService } from 'primeng/dynamicdialog';
import { Proforma, ProformaService } from '@app/_components/proforma';
import { ProformaComponent } from '@app/_components/proforma/proforma/proforma.component';
import { SendFullMailComponent } from '@app/_components/msg/send-full-mail/send-full-mail.component';
import { RealEstateComponent } from '../real-estate/real-estate.component';

@Component({
    selector: 'app-real-estate-list',
    templateUrl: './real-estate-list.component.html',
    styleUrls: ['./real-estate-list.component.css'],
    providers: [DialogService, MessageService, ConfirmationService, { provide: MAT_DIALOG_DATA, useValue: {} }],
    // make column heading sticky
    styles: [`
        :host ::ng-deep .p-datatable .p-datatable-thead > tr > th {
            position: -webkit-sticky;
            position: sticky;
            top: 0px;
        }

        @media screen and (max-width: 64em) {
            :host ::ng-deep .p-datatable .p-datatable-thead > tr > th {
                top: 99px;
            }
        }
`],
    standalone: false
})
export class RealEstateListComponent implements OnInit {
	constructor(
		private realEstateService: RealEstateService,
		private alertService: AlertService,
		private messageService: MessageService,
		private dialogService: DialogService,
		private proformaService: ProformaService,
		private confirmationService: ConfirmationService,
		private dialog: MatDialog,
	) {
		this.statuses = realEstateService.statuses
	}



	// data
	@Input() showFilter = true;
	@Input() showPagination = true;
	@Input() outlineNewButton = true;
	realEstates: any;
	realEstate: RealEstate;

	// paging
	first = 0;
	rows = 50;

	// list
	datasource: any;

	recordTotal: number;
	lazyLoadEvent: LazyLoadEvent;
	loading = true;
	multiSortMeta = [];

	// forms
	formLoading = false;

	msg: Msg;
	shareProformaEmail: any = 'https://www.kbmresorts.com/proforma/CONFID/honua-kai/hkh-236';

	statuses: any;

	columns: any[] = [
		{allowSort: true, field: 'mlsAllId', header: 'Id', width: 'auto' },

		{allowSort: true, field: 'mlsNumber', header: 'mlsNumber', width: 'auto' },
		{allowSort: false, field: 'propertyImage', header: 'Property', width: 'auto' },
		{allowSort: true, field: 'kbmPropertyType', header: 'KBM PropertyType', width: 'auto' },
		{allowSort: true, field: 'createDate', header: 'Create Date', width: 'auto' },
		{allowSort: true, field: 'lastUpdate', header: 'Last Update', width: 'auto' },


		{allowSort: true, field: 'listingPrice', header: 'Price', width: 'auto' },
		{allowSort: true, field: 'statusDesc', header: 'Status', width: 'auto' },

		{allowSort: true, field: 'addressZip', header: 'Zip Code', width: 'auto' },
	];

	propertyOptions: any = this.realEstateService.propertyOptions;

	ngOnInit(): void {
		try {
			// default sort of list
			this.multiSortMeta = [];
			this.multiSortMeta.push({ field: 'mlsAllId', order: 0 });
		}
		catch (error) {
			console.log('Error: ' + error);
		}
	}

	/*********
	 * Delete Button
	 *
	 *
	onRowDelete(event: any) {
		console.log('onRowDelete: ' + JSON.stringify(event));
		this.confirmationService.confirm({
			message: 'Are you sure you want to delete Id# ' + event.realEstateId + '?',
			header: 'Confirm',
			icon: 'pi pi-exclamation-triangle',
			accept: () => {
				this.formDelete(event);
			},
			reject: () => {
				this.messageService.add({ severity: 'info', summary: 'Canceled', detail: 'Delete canceled.', life: 3000 });
			}
		});
	}


	/*********
	 * Lazy Load All Data
	 *
	 */
	loadLazy(event: LazyLoadEvent) {
		try {
			this.loading = true;
			this.lazyLoadEvent = event;

			console.log(
				' event.first:' + event.first
				+ '  |  event.rows:' + event.rows
				+ '  |  event.sortField:' + event.sortField
				+ '  |  event.sortOrder:' + event.sortOrder
				+ '  |  event.multiSortMeta:' + JSON.stringify(event.multiSortMeta)
				+ '  |  event.globalFilter:' + event.globalFilter
				+ '  |  event.filters:' + JSON.stringify(event.filters)
			);

			/*
			*
			* Default Sort
			*/
			// https://stackoverflow.com/questions/679915/how-do-i-realEstate-for-an-empty-javascript-object
			// if we are NOT filtering and we are NOT sorting, apply a default sort
			if (Object.keys(event.filters).length === 0 && !event.multiSortMeta) {
				event.multiSortMeta = [];
				event.multiSortMeta.push({ field: 'mlsAllId', order: -1 });
			}

			const pageNumber = Math.round(event.first / event.rows);
			this.realEstateService.findByFilter(
				pageNumber, event.rows,
				event.sortField,
				event.sortOrder,
				event.multiSortMeta,
				event.globalFilter,
				event.filters).pipe(first()).subscribe(

					(res: any) => {
						this.datasource = res.data.reviews;
						this.recordTotal = res.page.recordTotal;
						this.realEstates = res.data.realEstates;
						console.log(JSON.stringify(res.page));
					},
					(err: any) => {
						console.log('reviews list error!: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.loading = false; }
				);

			if (this.datasource) {
				this.realEstates = this.datasource.slice(event.first, (event.first + event.rows));
			}
		} catch (error) {
			console.log('loadLazy(' + event + ')' + error);
		}
	}

	formatCurrency(text: any) {
		return Utils.formatPriceNoFractionDigits(text);
	}


	getImageURL(realEstate: any){

		let url = "https://s3.us-east-1.amazonaws.com/img.kbmrealestate.com/residential.jpg";
		if(realEstate?.numOfPictures > 0 && realEstate.kbmPropertyType){
			url = 'https://s3.us-east-1.amazonaws.com/img.kbmrealestate.com/' + realEstate?.mlsName +'/img-'
				+ realEstate?.mlsName + '-'+ realEstate?.kbmPropertyType + '-'+ realEstate?.mlsNumber + '_1.jpg'
			url = url.toLowerCase();

		}
		console.log("fav property URL : "+url);

		return url;
	}

	getStatus() {
		return
	}

	onActionSelection(event: any, property: any) {
		if(event.value == 1) {
			this.requestProforma(property);
		} else if(event.value == 2) {
			this.sendProforma(property, false);
		} else if(event.value == 3) {
			this.sendProforma(property, true);
		}
	}

	sendProforma(property: any, sendToRealtor: boolean) {
		let request: any = {
			mlsAllId : property.mlsAllId,
			realtorEmail : property.listingAgentEmail,
			realtorName : property.listingAgentName,
			realtorPhone : property.listingAgentPhone,
			sendToRealtor: sendToRealtor
		};
		try {
			this.loading = true;
			this.proformaService.sendProformaToRealtor(request).subscribe(
				(res: any) => {
					console.log("Realtor created SUCCESS: " + JSON.stringify(res));
					this.sendFullMail(res.data.proforma);
				},
				(err: any) => {
					console.log("property-request FAIL: " + JSON.stringify(err));
					this.alertService.error(err);
					this.loading = false;
				},
				() => {
					this.loading = false;
				}
			);
		} catch (error) {

		this.alertService.error(error);
		}
	}

	sendFullMail(proforma: any) {
		let property =  proforma.propertyLeadProfile;
		let propertyName = "";
		if(property?.subjAdrDevelopmentName != undefined)  {
		  propertyName = propertyName + property?.subjAdrDevelopmentName;
		}
		if(property?.subjAdrUnit != undefined) {
		  propertyName = propertyName == "" ? '#' + property?.subjAdrUnit : propertyName + " #" + property?.subjAdrUnit;
		}
		if(property?.subjAdrStreet != undefined && propertyName == "") {
		  propertyName = property?.subjAdrStreet;
		}

		let createdBy = proforma.createByProfile;
		let regards = '';
		regards = createdBy?.firstName != undefined ? createdBy?.firstName : '';
		regards = createdBy?.lastName != undefined ? regards == '' ? createdBy?.lastName : regards + ', ' + createdBy?.lastName: regards + '';
		regards = regards == '' ? createdBy?.emailAddress != undefined ? createdBy?.emailAddress : '' : regards + '<br>' + (createdBy?.emailAddress != undefined ? createdBy?.emailAddress : '');
		regards = regards == '' ? (createdBy?.mobilePhone != undefined ? createdBy?.mobilePhone : '') : (regards + '<br>' + (createdBy?.mobilePhone != undefined ? createdBy?.mobilePhone : ''));
		regards = regards == '' ? (createdBy?.title != undefined ? createdBy?.title : '') : (regards + '<br>' + (createdBy?.title != undefined ? createdBy?.title : ''));

		let realtorProfile = proforma.realtorProfile;
		const dialogConfig = new MatDialogConfig();
		this.msg = new Msg();
		this.msg.subject = 'Proforma Details';
		this.msg.emailHtml = 'Hi ' + (realtorProfile != undefined ? realtorProfile?.firstName : '')
		+ ' <br> <br> Please find your rent analysis for ' + propertyName
		+ ' <br> <br> <a href="'+ this.shareProformaEmail +'">'+ this.shareProformaEmail +'</a>'
		+ ' <br> <br> Please explore the income potential by selecting between Stable, Contracting, and Expanding markets to see how our analysis indicates your home will perform under varying economic conditions.'
		+ '<br> <br> I look forward to learning more about your home and am available to discuss anytime at your convenience. <br> <br>'
		+ 'Best, <br>'
		+ regards;

		this.msg.topic = 700; // 700 is proforma
		this.msg.topicId = proforma.proformaId;

		// settings
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.hasBackdrop = true;

		// pass data, ie rateBuicket: this.shortTermRentalId,
		dialogConfig.data = {
		  title: "send mail",
		  msg: this.msg,
		  toEmails: realtorProfile?.emailAddress,
		  ccEmails: '',
		  bccEmails: '',
		  proforma: proforma
		};

		// open the popup and get a reference to it called dialogRef
		const dialogRef:any = this.dialog.open(SendFullMailComponent, dialogConfig);

		dialogRef.componentInstance.doAdd.subscribe((data:any) => {
		  console.log("Dialog output:", data);
		  this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Proforma ' + proforma?.name + ' shared successfully.', life: 3000 });
		  // when we doAdd in the element, call this parent and update the list so it shows the added element to the database
		  // this.addMsgCB(data);

		  // close the dialogBox
		  // dialogRef.close();
		});
	  }

	requestProforma(property: any) {
		console.log(property)
		let request: any = {
			mlsAllId : property.mlsAllId,
			addressStreetNumber : property.addressStreetNumber,
			addressStreetName : property.addressStreetName,
			addressUnit : property.addressUnit,
			addressCity : property.addressCity,
			addressState : property.addressState,
			addressZip : property.addressZip,
		};
		try {
			this.loading = true;
			this.proformaService.requestProforma(request).subscribe(
				(res: any) => {
					console.log("property-request SUCCESS: " + JSON.stringify(res));
					this.showProforma(res.data.proforma);
				},
				(err: any) => {
					console.log("property-request FAIL: " + JSON.stringify(err));
					this.alertService.error(err);
					this.loading = false;
				},
				() => {
					this.loading = false;
				}
			);
		} catch (error) {

		this.alertService.error(error);
		}
	}

	showProforma(proforma: Proforma) {
		const dialogConfig = new MatDialogConfig();

		// settings
		dialogConfig.maxWidth = "100vw";
		dialogConfig.width = "80vw";
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.hasBackdrop = true;

		// pass data, ie rateBuicket: this.shortTermRentalId,
		dialogConfig.data = {
			proforma: proforma,
			title: 'Edit Proforma'
		};

		// open the popup and get a reference to it called dialogRef
		const dialogRef = this.dialog.open(ProformaComponent, dialogConfig);

		// to receive the added element, subscribe to the eventEmitter we created 'doUpdate' in the element to handle updating the list
		dialogRef.componentInstance.doUpdate.subscribe(
			data => {
				console.log('Dialog output:', data);

				// close the dialogBox
				// dialogRef.close();
			});

		// to open the copied proforma
		dialogRef.componentInstance.doOpenCopiedProforma.subscribe(
			data => {
				console.log('doOpenCopiedProforma Dialog output:', data);
				// close the dialogBox
				if(data != undefined) {

				}
				dialogRef.close();
			});
	}

	/*********
	 * onRowSelect()
	 * Used to handle row click (to edit, link, etc)
	 *
	onRowSelect(event: any) {
		console.log('onRowSelect: ' + JSON.stringify(event));
		this.onOpenFormEdit(event.data);
	}

	// handled in rate-bucket-form
	formAdd() { }


	/*********
	 * formUpdate()
	 * Used for row editing
	 *
	formUpdate(realEstate: RealEstate) {
		try {
			this.formLoading = true;
			this.realEstateService.update(realEstate)
				.subscribe(
					(res: any) => {
						console.log('Rate-Bucket-Update SUCCESS: ' + JSON.stringify(res));
						this.realEstates.map((realEstate, i) => {
							if (realEstate.realEstateId === res.data.realEstate.realEstateId) {
								this.realEstates[i] = res.data.realEstate;
							}
						});
						// this.alertService.success(res, true);
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
					},
					(err: any) => {
						console.log('Rate-Bucket-Update FAIL: ' + JSON.stringify(err));
						this.messageService.add({ severity: 'error', summary: JSON.stringify(err), life: 3000 });
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	/*********
	 * formDelete()
	 * Used for row editing
	 *
	formDelete(realEstate: any) {
		try {
			// stop here if form is invalid
			console.log('Delete Submitted: ' + JSON.stringify(realEstate));

			this.formLoading = true;
			this.realEstateService.delete(realEstate.realEstateId)
				.subscribe(
					(res: any) => {
						console.log('Rate-Bucket-Delete SUCCESS: ' + JSON.stringify(res));
						this.realEstates.splice(this.realEstates.indexOf(realEstate), 1);
						this.recordTotal = this.realEstates.length;
						this.messageService.add({ severity: 'success', summary: 'Successful', detail: 'RealEstate ' + realEstate.realEstateId + ' Deleted', life: 3000 });
					},
					(err: any) => {
						console.log('Rate-Bucket-Delete  FAIL: ' + JSON.stringify(err));
						this.messageService.add({ severity: 'error', summary: 'Delete Failed', detail: 'RealEstate ' + realEstate.realEstateId + ' could not be deleted.  Be sure there are no assigned properties to this bucket.', life: 3000 });
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	/*********
		 * Add New Button
		 *
		 *
	onOpenFormAdd() {

		const dialogConfig = new MatDialogConfig();

		// settings
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.hasBackdrop = true;

		// pass data, ie rateBuicket: this.shortTermRentalId,
		dialogConfig.data = {
			title: 'Add RealEstate'
		};

		// open the popup and get a reference to it called dialogRef
		const dialogRef = this.dialog.open(RealEstateComponent, dialogConfig);

		// to receive the added element, subscribe to the eventEmitter we created 'doAdd' in the element to handle adding
		dialogRef.componentInstance.doAdd.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.addRealEstateCB(data);

				// close the dialogBox
				dialogRef.close();
			});
	}


	/*********
		* Edit Button
		*
		*
	onOpenFormEdit(realEstate: RealEstate) {

		const dialogConfig = new MatDialogConfig();

		// settings
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.hasBackdrop = true;

		// pass data, ie rateBuicket: this.shortTermRentalId,
		dialogConfig.data = {
			realEstate: realEstate,
			title: 'Edit RealEstate'
		};

		// open the popup and get a reference to it called dialogRef
		const dialogRef = this.dialog.open(RealEstateComponent, dialogConfig);

		// to receive the added element, subscribe to the eventEmitter we created 'doUpdate' in the element to handle updating the list
		dialogRef.componentInstance.doUpdate.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.updateRealEstateCB(data);

				// close the dialogBox
				dialogRef.close();
			});

		dialogRef.componentInstance.doDelete.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.deleteRealEstateCB(data);

				// close the dialogBox
				dialogRef.close();
			});
	}


	/**
	   *
	   * Dialog from Form Callbacks
	   * To edit the list show add/edit/delete in real time from the popup form
	   *
	   *
	addRealEstateCB(realEstate: RealEstate) {
		console.log('Adding RealEstate: ' + JSON.stringify(realEstate));
		// if we don't have a realEstates array yet...
		if (!this.realEstates) {
			this.realEstates = [];
		}
		// unshift adds to the front of the array (), push adds to the back
		this.realEstates.unshift(realEstate);

		// no idea what this is but it is required to update the array
		this.realEstates = [...this.realEstates];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'RealEstate ' + realEstate.realEstateId + ' Added', life: 3000 });
	}

	updateRealEstateCB(realEstate: RealEstate) {
		console.log('Updating RealEstate: ' + JSON.stringify(realEstate));
		let itemIndex = this.realEstates.findIndex((item: any) => item.realEstateId === realEstate.realEstateId);
		this.realEstates[itemIndex] = realEstate;

		// no idea what this is but it is required to update the array
		this.realEstates = [...this.realEstates];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'RealEstate ' + realEstate.realEstateId + ' Updated', life: 3000 });
	}

	deleteRealEstateCB(realEstate: RealEstate) {
		console.log('Removing RealEstate: ' + realEstate);
		this.realEstates.splice(this.realEstates.indexOf(realEstate), 1);
		this.recordTotal = this.realEstates.length;

		// no idea what this is but it is required to update the array
		this.realEstates = [...this.realEstates];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'RealEstate ' + realEstate.realEstateId + ' Deleted', life: 3000 });
	}

	/**********
	 *
	 * PAGINATOR FUNCTIONS
	 */
	next() { this.first = this.first + this.rows; }
	prev() { this.first = this.first - this.rows; }
	reset() { this.first = 0; }
	isLastPage(): boolean { return this.realEstates ? this.first === (this.realEstates.length - this.rows) : true; }
	isFirstPage(): boolean { return this.realEstates ? this.first === 0 : true; }

	get Statuses() {
		return this.statuses;
	}

	getStatusName(realEstate: any) {
		if (realEstate?.status) {
			const status = this.statuses.find((e: any) => e.value == realEstate.status);
			return status.name;
		}
		else {
			return '';
		}
	}

	reloadPage() {
		window.location.reload();
	}

	showPaginator()
	{
		return true;
	}
}
